var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Legends',{staticClass:"mb",attrs:{"title":"人员信息","list":_vm.legends,"sub-window":"members"},on:{"sub-window":function($event){return _vm.$emit("sub-window", $event)}}}),_c('BarChart',{staticClass:"mb",attrs:{"legends":_vm.legends,"list":_vm.membersOn,"tail":"共#人","round":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }